export default "__VITE_ASSET__DccXIPjA__"